import { render, staticRenderFns } from "./ThemesTable.vue?vue&type=template&id=c0f7606e"
import script from "./ThemesTable.vue?vue&type=script&lang=js"
export * from "./ThemesTable.vue?vue&type=script&lang=js"
import style0 from "./ThemesTable.vue?vue&type=style&index=0&id=c0f7606e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports